import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import { Button, colors, Heading, Link, Spinner, TextField } from '@telia/styleguide';
import { useStore } from '../../store/store';
import { MediaQueries } from '../../util/MediaQueries';
import { RequestStatus } from '../../util/RequestStatus';
import { routes } from '../../util/utils';
import SummaryWidget from '../../modules/summary/SummaryWidget';
import { useFWAOrder } from '../../hooks/FWAOrderContext';

const Personalia: React.FC<RouteComponentProps> = props => {
  const { personaliaForm } = useFWAOrder();
  const { state } = useStore();
  const { packages, sale, updateCustomer } = state;
  const { form, updateCustomerOnCommit } = personaliaForm;

  useEffect(() => {
    if (!packages.selectedPackage) {
      return props.history.push(routes.address);
    }
  }, []);
  const tryggPaaNettID = 1818;
  const simcardId = 1887;
  const fiveGAntenna = 1935;
  const CPE = 639;
  const movieRent = 205;
  const liveTV = 1827;
  // const TeliaBox = 1711;
  //[1887, 1818, 1935, 205, 1827, 1711, 639];

  const hiddenProducts = [tryggPaaNettID, simcardId,fiveGAntenna, CPE, movieRent, liveTV];

  let summarySalesPackage = undefined;
  const { selectedPackage } = packages;
  if (selectedPackage) {
    summarySalesPackage = {
      ...selectedPackage,
      products: selectedPackage
        ? selectedPackage.products.filter(product => !hiddenProducts.includes(product.commercialProductId))
        : []
    };
  }
  return (
    <StyledForm>
      {(updateCustomer.status === RequestStatus.PENDING || sale.saleStatus === RequestStatus.PENDING) && <Spinner />}
      <Wrapper>
        <FormWrapper>
          <StyledHeading size={'m'} tag={'h2'} text={'DIN KONTAKTINFO'} />
          <StyledTextField
            label={'Fornavn'}
            name={'firstName'}
            value={form.values.firstName}
            error={!form.isFieldValid('firstName') && form.isFieldTouched('firstName') && form.errors.firstName}
            helpText={!form.isFieldValid('firstName') && form.isFieldTouched('firstName') && 'Må fylles ut'}
            onChange={e => form.setValue('firstName', e.target.value)}
          />
          <StyledTextField
            label={'Etternavn'}
            name={'lastName'}
            value={form.values.lastName}
            error={!form.isFieldValid('lastName') && form.isFieldTouched('lastName') && form.errors.lastName}
            helpText={!form.isFieldValid('lastName') && form.isFieldTouched('lastName') && 'Må fylles ut'}
            onChange={e => form.setValue('lastName', e.target.value)}
          />
          <Label>Fødselsdato</Label>
          <DateInputFields>
            <TwoDigitField
              value={form.values.day}
              name={'day'}
              error={!form.isFieldValid('day') && form.isFieldTouched('day') && form.errors.day}
              helpText={!form.isFieldValid('day') && form.isFieldTouched('day') && 'Oppgi gyldig dag'}
              onChange={e => form.setValue('day', e.target.value)}
              placeholder={'DD'}
            />
            <TwoDigitField
              value={form.values.month}
              name={'month'}
              error={!form.isFieldValid('month') && form.isFieldTouched('month') && form.errors.month}
              helpText={!form.isFieldValid('month') && form.isFieldTouched('month') && 'Oppgi gyldig måned'}
              onChange={e => form.setValue('month', e.target.value)}
              placeholder={'MM'}
            />
            <FourDigitField
              value={form.values.year}
              name={'year'}
              error={!form.isFieldValid('year') && form.isFieldTouched('year') && form.errors.year}
              helpText={!form.isFieldValid('year') && form.isFieldTouched('year') && 'Oppgi gyldig år'}
              onChange={e => form.setValue('year', e.target.value)}
              placeholder={'YYYY'}
            />
          </DateInputFields>
          <StyledTextField
            label={'E-post'}
            name={'email'}
            value={form.values.email}
            error={!form.isFieldValid('email') && form.isFieldTouched('email') && form.errors.email}
            helpText={!form.isFieldValid('email') && form.isFieldTouched('email') && 'må være på formen xxx@xxx.xxx'}
            onChange={e => form.setValue('email', e.target.value)}
          />
          <PhoneNumberTextField
            label={'Telefonnummer'}
            name={'phoneNumber'}
            value={form.values.phoneNumber}
            error={!form.isFieldValid('phoneNumber') && form.isFieldTouched('phoneNumber') && form.errors.phoneNumber}
            helpText={
              !form.isFieldValid('phoneNumber') &&
              form.isFieldTouched('phoneNumber') &&
              'må starte med 4 eller 9 og være 8 tall.'
            }
            onChange={e => form.setValue('phoneNumber', e.target.value)}
          />
        </FormWrapper>
        <div>
          {packages.selectedPackage && summarySalesPackage && (
            <SummaryWidget
              selectedBundle={summarySalesPackage}
              selectedAdditionalProducts={packages.selectedAdditionalProducts}
            />
          )}
        </div>
      </Wrapper>
      <ButtonContainer>
        <Link
          href={''}
          onClick={(e: React.MouseEvent<HTMLElement>) => {
            e.preventDefault();
            props.history.goBack();
          }}
          text="Tilbake"
          icon={'arrow-left'}
          iconPosition={'before'}
        />
        <HorizontalSpacer />
        <Button
          onClick={updateCustomerOnCommit}
          kind={'primary'}
          type={'submit'}
          isDisabled={
            form.hasFormFieldError ||
            updateCustomer.status === RequestStatus.PENDING ||
            sale.saleStatus === RequestStatus.PENDING
          }
          text="Bekreft kjøp"
        />
      </ButtonContainer>
    </StyledForm>
  );
};

export default Personalia;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  padding: 0 3rem;
  max-width: 1350px;
  width: 100%;
  ${MediaQueries.onlyMobile} {
    padding: 0;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  width: 100%;
  ${MediaQueries.desktop} {
    flex-direction: row;
  }
`;

const FormWrapper = styled.div`
  width: 100%;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  ${MediaQueries.notDesktop} {
    align-self: flex-start;
  }
  ${MediaQueries.desktop} {
    margin-right: 2rem;
  }
`;

const StyledHeading = styled(Heading)`
  && {
    color: ${colors.corePurple};
    font-family: Pebble, Helvetica, Roboto, Arial, sans-serif;
    align-self: flex-start;
  }
`;

const Label = styled.label`
  font-size: 14px;
`;

const StyledTextField = styled(TextField)`
  && {
    width: 100%;
  }
`;

const DateInputFields = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 1rem;
`;

const TwoDigitField = styled(TextField)`
  && {
    width: 25%;
  }
`;

const FourDigitField = styled(TextField)`
  && {
    width: 50%;
  }
`;
const PhoneNumberTextField = styled(TextField)`
  && {
    width: 100%;
    max-width: 10rem;
  }
`;

const ButtonContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  align-items: center;
  align-self: flex-end;
  ${MediaQueries.onlyMobile} {
    margin-right: 1rem;
  }
`;

const HorizontalSpacer = styled.div`
  margin: 0 1rem;
`;
